<div>
    <div class="py-2" style="min-width: 20rem" [style.flex-grow]="'1'" [style.overflow-y]="'auto'">
        @if (config.data) {
            <app-json-schema-form
                #jsonSchemaForm
                [schema]="config.data.schema"
                [rootSchema]="config.data.rootSchema"
                [initData]="config.data.data"
                [readOnly]="config.data.readOnly!"
                (validityChangedEvent)="_isJsonSchemaFormValid = $event"
            ></app-json-schema-form>
        }
    </div>

    <div class="p-dialog-footer">
        <p-button
            severity="secondary"
            icon="pi pi-times"
            type="button"
            [severity]="config.data?.cancelButtonSeverity ?? 'secondary'"
            [icon]="config.data?.cancelButtonIcon"
            [label]="config.data?.cancelButtonLabel!"
            [disabled]="_isSubmitting"
            (click)="onCancel()"
        />

        <p-button
            [severity]="config.data?.validateButtonSeverity ?? 'primary'"
            [icon]="config.data?.validateButtonIcon"
            [label]="config.data?.validateButtonLabel!"
            [disabled]="!_isJsonSchemaFormValid || _isSubmitting"
            (click)="onValidate()"
        />
    </div>
</div>
